import React from 'react'
import Reports from '../features/Reports/Reports'

export default function MainReport() {
  return (
    <Reports />
  )
}
